import React, { useState, useEffect, useContext } from 'react'
import { withRouter, useParams } from 'react-router-dom'
import { Row, Col, Container } from 'reactstrap'
import { isEmpty, remove, find } from 'lodash'
import { isMobile } from 'react-device-detect'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import ApiService from '../../data/services/ApiService'
import { GeneralContext } from '../../context/'
import { getImagesOfProduct } from '../../helpers/utils'
import MollaProductCard from '../../components/Molla/ProductCard'
import MollaFilters from '../../components/Molla/Filters'
import Pagination from '../../components/Molla/Pagination'
import SupplierLogoCard from '../../components/Common/Cards/SupplierLogo'

const LIMIT = 40

const catalogPublicUrl = `https://mitiendasocial.com/`

const Index = (props) => {
  const generalContext = useContext(GeneralContext)
  const { setLoading, setCurrentRoute, pagination } = generalContext

  const { supplierCode } = useParams()

  const [products, setProducts] = useState([])
  const [totalCount, setTotalCount] = useState(0)

  const plpPagination = find(pagination, { currentRoute: props.location.pathname })
  const [offset, setOffset] = useState(!isEmpty(plpPagination) ? (plpPagination.plpPage - 1) * LIMIT : 0)

  const [supplier, setSupplier] = useState({})

  const [families, setFamilies] = useState([])
  const [filterFamilies, setFilterFamilies] = useState([])
  const [categories, setCategories] = useState([])
  const [filterCategories, setFilterCategories] = useState([])
  const [subcategories, setSubcategories] = useState([])
  const [filterSubcategories, setFilterSubcategories] = useState([])
  const [minPrice, setMinPrice] = useState(0)
  const [maxPrice, setMaxPrice] = useState(0)
  const [filterPrice, setFilterPrice] = useState([])
  const [searcher, setSearcher] = useState('')

  async function getFamilies() {
    try {
      setLoading(true)
      const response = await ApiService.getFamiliesBySupplierCode(supplierCode)
      setFamilies(response.data.data)
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  async function getRangePrice() {
    try {
      setLoading(true)
      const response = await ApiService.getRangePriceBySupplierCode(supplierCode)
      if (!isEmpty(response.data)) {
        setMaxPrice(!isEmpty(response.data.maxPrice.wholeSalePrice) ? parseInt(response.data.maxPrice.wholeSalePrice, 10) : 0)
        setMinPrice(!isEmpty(response.data.minPrice.wholeSalePrice) ? parseInt(response.data.minPrice.wholeSalePrice, 10) : 0)
      }
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  async function getCategories() {
    try {
      setLoading(true)
      const response = await ApiService.getCategoriesBySupplierCode(supplierCode, filterFamilies)
      setCategories(response.data.data)
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  async function getSubcategories() {
    try {
      setLoading(true)
      const response = await ApiService.getSubcategoriesBySupplierCode(supplierCode, filterFamilies, filterCategories)
      setSubcategories(response.data.data)
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  async function fetchProducts() {
    try {
      setLoading(true)
      const response =
        await ApiService.getProductsBySupplierCode(
          supplierCode,
          offset,
          LIMIT,
          filterFamilies,
          filterCategories,
          filterSubcategories,
          filterPrice,
          searcher,
      )

      const { products, count, supplier } = response.data

      setSupplier(supplier)
      setProducts(products)
      setTotalCount(count)

      if (count === 1) {
        window.analytics.track("Searched for exact product", {
          product: {
            productId: products[0].id,
            productName: products[0].name,
            productCode: products[0].code,
            gender: products[0].gender,
            model: products[0].model,
            providerName: products[0].supplier.nombreComercial,
            brand: products[0].brand.name,
            family: products[0].family.name,
            category: products[0].category.name,
            subcategory: products[0].subcategory.name,
            buyPrice: products[0].buyPrice,
            wholeSalePrice: products[0].wholeSalePrice,
            retailPrice: products[0].retailPrice,
            description: products[0].description,
            variants: products[0].variants,
          }
        })

        props.history.push(`/producto/${products[0].slug}`)
      }
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  const changePage = (page) => {
    setOffset(page * LIMIT)
    window.scrollTo({ top: 0 })
  }

  useEffect(() => {
    (async function fetch() {
      await getRangePrice()
    })()
  }, []) // eslint-disable-line

  useEffect(() => {
    (async function fetch() {
      await getFamilies()
    })()
  }, []) // eslint-disable-line

  useEffect(() => {
    (async function fetch() {
      await getCategories()
    })()
  }, [filterFamilies]) // eslint-disable-line

  useEffect(() => {
    (async function fetch() {
      await getSubcategories()
    })()
  }, [filterFamilies, filterCategories]) // eslint-disable-line

  useEffect(() => {
    (async function fetch() {
      await fetchProducts()
    })()
  }, [offset, filterFamilies, filterCategories, filterSubcategories, filterPrice, searcher]) // eslint-disable-line

  useEffect(() => {
    setCurrentRoute(props.location.pathname)
  }, [props]) // eslint-disable-line

  const itemAction = (product) => {
    window.analytics.track("Go to product page", {
      product: {
        productId: product.id,
        productName: product.name,
        productCode: product.code,
        gender: product.gender,
        model: product.model,
        providerName: product.supplier.nombreComercial,
        brand: product.brand.name,
        family: product.family.name,
        category: product.category.name,
        subcategory: product.subcategory.name,
        buyPrice: product.buyPrice,
        wholeSalePrice: product.wholeSalePrice,
        retailPrice: product.retailPrice,
        description: product.description,
        variants: product.variants,
      },
    })
    props.history.push(`/producto/${product.slug}`)
  }

  const familyChecked = (event, value) => {
    setProducts([])
    setOffset(0)
    if (event.target.checked) {
      const filter = filterFamilies
      filter.push(value.id)
      setFilterFamilies([...filter])
    } else {
      const filter = filterFamilies
      remove(filter, n => n === value.id)
      setFilterFamilies([...filter])
    }
  }

  const categoryChecked = (event, value) => {
    setProducts([])
    setOffset(0)
    if (event.target.checked) {
      const filter = filterCategories
      filter.push(value.id)
      setFilterCategories([...filter])
    } else {
      const filter = filterCategories
      remove(filter, n => n === value.id)
      setFilterCategories([...filter])
    }
  }

  const subcategoryChecked = (event, value) => {
    setProducts([])
    setOffset(0)
    if (event.target.checked) {
      const filter = filterSubcategories
      filter.push(value.id)
      setFilterSubcategories([...filter])
    } else {
      const filter = filterSubcategories
      remove(filter, n => n === value.id)
      setFilterSubcategories([...filter])
    }
  }

  const setPriceRange = (range) => {
    const filterRange = [range.min, range.max]
    setProducts([])
    setOffset(0)
    setFilterPrice(filterRange)
  }

  const clearAll = () => {
    setProducts([])
    setOffset(0)
    setFilterFamilies([])
    setFilterCategories([])
    setFilterSubcategories([])
  }

  const toggleFilters = () => {
    if (document.querySelector('body').classList.contains('sidebar-filter-active')) {
      document.querySelector('body').classList.remove('sidebar-filter-active')
    } else {
      document.querySelector('body').classList.add('sidebar-filter-active')
    }
  }

  const shareButtonAction = () => {
    const shareText = `%20Checa%20los productos%20%20de%20${supplier.nombreComercial},%20te%20van%20a%20encantar%20%F0%9F%A4%A9.%20Pregúntame%20por%20algo%20que%20te%20guste%20%f0%9f%98%89.%20`
    window.analytics.track("Brand PLP WA Shared", { brand: supplier.nombreComercial })
    window.open(`https://api.whatsapp.com/send?text=${shareText}${catalogPublicUrl}${supplier.supplierCode}`)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Marcas"
            breadcrumbItem="Productos"
            parentLink={`/marcas`}
          />
          <SupplierLogoCard 
            supplier={supplier}
            shareButtonAction={shareButtonAction}
          />
          <div className="toolbox">
            <Row style={{ display: 'flex' }}>
              <Col xs={isMobile ? 10 : 12} className="toolbox-info text-center" style={{ alignSelf: 'center' }}>
                <span>{products ? products.length : 0} de {totalCount ? totalCount : 0}</span> Productos
              </Col>
              {isMobile && (
                <Col xs="2">
                  <button
                    style={{ cursor: 'pointer', border: '1px solid grey', marginRight: '5px' }}
                    className={`btn btn-default waves-effect waves-light`}
                    onClick={toggleFilters}
                  >
                    Filtros
                  </button>
                </Col>
              )}
            </Row>
          </div>
          <Row>
            <Col sm="9" style={{ paddingLeft: 0, paddingRight: 0 }}>
              <div className="row">
                {!isEmpty(products) && products.map((item, key) => (
                  <MollaProductCard
                    key={key}
                    keyItem={key}
                    gallery={getImagesOfProduct(item.gallery)}
                    itemAction={() => itemAction(item)}
                    item={item}
                  />
                ))}
              </div>
            </Col>
            <div className="col-lg-3 order-lg-first">
              <MollaFilters
                clearAll={clearAll}
                adClass="sidebar sidebar-shop"
                minPrice={minPrice}
                maxPrice={maxPrice}
                setPriceRange={setPriceRange}
                families={families}
                familyChecked={familyChecked}
                categories={categories}
                categoryChecked={categoryChecked}
                subcategories={subcategories}
                subcategoryChecked={subcategoryChecked}
                showBrands={false}
                showSuppliers={false}
                showSearcher
                setSearcher={setSearcher}
              />
            </div>
          </Row>
          <Pagination
            aclass="justify-content-center"
            count={totalCount}
            unit={LIMIT}
            onChange={changePage}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Index)
